import GenericModel from '../generic-model';
import Coordinates from '../coordinates';

export default class Address extends GenericModel {
  line1: string;
  postalCode: string;
  city: string;
  province: string;
  country: string;
  addressee: string;
  coordinates?: Coordinates;

  constructor() {
    super();
  }
}
